import React from 'react';

import get from 'lodash/get';

import styles from './index.module.css';

import NoCapabilityIcon from '../../assets/no-capability';

import { FrameworkDocumentationLink } from '../../constants/View';
import { EventsMap } from '../../constants/events';
import { sendAmplitudeEvents } from '../../utils/utilityFunctions';

import { LTButton } from '@lambdatestincprivate/lt-components';

const MissingCapabilityByTestType = {
  selenium: {
    docsLink: FrameworkDocumentationLink.SELENIUM,
    showDocs: true,
    showAdditionalInfo: true,
    showCapabilityCode: true,
    capabilityPrefix: 'let capability = ',
    capabilitySuffix: '',
  },
  cypress: {
    docsLink: FrameworkDocumentationLink.CYPRESS,
    showAdditionalInfo: false,
    showDocs: true,
    showCapabilityCode: true,
    capabilityPrefix: "'run_settings': ",
    capabilitySuffix: '',
  },
  taiko: {
    showAdditionalInfo: false,
    showDocs: false,
    showCapabilityCode: true,
    capabilityPrefix: "let capability = {'LT:Options': ",
    capabilitySuffix: '}',
  },
  puppeteer: {
    showAdditionalInfo: false,
    showDocs: false,
    showCapabilityCode: true,
    capabilityPrefix: "let capability = {'LT:Options': ",
    capabilitySuffix: '}',
  },
  playwright: {
    showAdditionalInfo: false,
    showDocs: false,
    showCapabilityCode: true,
    capabilityPrefix: "let capability = {'LT:Options': ",
    capabilitySuffix: '}',
  },
  k6: {
    showAdditionalInfo: false,
    showDocs: false,
    showCapabilityCode: true,
    capabilityPrefix: "let capability = {'LT:Options': ",
    capabilitySuffix: '}',
  },
};

function getInfoToDisplayByType(infoType, testType) {
  return get(MissingCapabilityByTestType, [testType, infoType], '');
}

function renderMissingCapabilityText(capabilityLabel) {
  return (
    <>
      To enable, please use the below mentioned flag in your test capabilites
      configuration to get the {`${capabilityLabel}`}
    </>
  );
}

function CapabilityScreen(props) {
  const {
    capabilityName = '',
    capabilityLabel = '',
    isMissingCapability = false,
    testType = '',
    textToShow = '',
  } = props;

  const capabilityPrefix = getInfoToDisplayByType(
    'capabilityPrefix',
    testType?.toLowerCase()
  );

  const capabilitySuffix = getInfoToDisplayByType(
    'capabilitySuffix',
    testType?.toLowerCase()
  );

  const capabilityText = `${capabilityPrefix} { ${capabilityName}: true } ${capabilitySuffix}`;

  return (
    <div
      className={`${styles.missingCapabilityContainer}`}
      style={{
        height: '100%',
      }}
    >
      <div className={styles.missingCapabilityWrapper}>
        <NoCapabilityIcon />
        <div className={styles.missingCapabilityLabel}>
          {capabilityLabel} are not enabled for this test
        </div>
        <>
          {getInfoToDisplayByType('showCapabilityCode', testType) && (
            <>
              <div className={`${styles.flex} ${styles.capabilityDesc}`}>
                {isMissingCapability &&
                  renderMissingCapabilityText(capabilityLabel)}
                {!isMissingCapability && <div>{textToShow}</div>}
              </div>
              <div className={styles.capabilityCodeText}>{capabilityText}</div>
            </>
          )}
        </>
        {getInfoToDisplayByType('showDocs', testType) && (
          <div className={styles.docBtnWrapper}>
            <LTButton
              className={styles.docsBtn}
              onClick={() => {
                window.open(
                  getInfoToDisplayByType('docsLink', testType),
                  '_blank'
                );
                sendAmplitudeEvents(
                  EventsMap.TEST_DETAILS_NO_CAPABILITY_SEE_DOCS,
                  { type: capabilityLabel, isNewTheme: true }
                );
              }}
              variant={LTButton.Variant.PRIMARY}
            >
              See Documentation
            </LTButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default CapabilityScreen;
